;(function ( $ ) {

    /**
     *  clonableControl
     *  adds a button to duplicate a control
     *  the clonable control should have a name with this pattern: name[0]
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'clonableControl';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {

            var regex = /([a-z-_0-9]*)\[([0-9]*)\]/;
            var nameItems = $(this.element).attr('name').match(regex);
            nameItems.shift();
            this.nameBase = nameItems[0];
            this.nameIndex = parseInt(nameItems[1]);

            this.$formRow = $(this.element).parents('.form-row');
            this.$cloneButton = this.getCloneButtonMarkup();
            this.$formRow.append(this.$cloneButton);

            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            this.$formRow.find('.clone-button').on('click', function(e) {
                e.preventDefault();
                _this.addClonedControl();
            });
        },

        addClonedControl: function() {
            var $fieldset = $('<fieldset />');
            this.nameIndex++;
            var $input = $('<input type="' + $(this.element).attr('type') + '" ' +
                'class="' + $(this.element).attr('class') + '" ' +
                'placeholder="' + $(this.element).attr('placeholder') + '" '+
                'name="' + this.nameBase + '[' + this.nameIndex + ']" />');
            $input.css({ 'margin-top': '20px' });
            $fieldset.append($input);
            this.$formRow.find('.clone-button').before($fieldset);
            var $newFieldset = $(this.element).parents('.form-row').find('fieldset').last();
            if ($(this.element).data('validate-msg')) {
                $newFieldset.find('input').data('validate-msg', $(this.element).data('validate-msg'));
            }
            if ($(this.element).data('required-msg')) {
                $newFieldset.find('input').data('required-msg', $(this.element).data('required-msg'));
            }
            if ($newFieldset.find('input').hasClass('required') || $newFieldset.find('input').hasClass('validate')) {
                $newFieldset.find('input').validate();
            }
        },

        getCloneButtonMarkup: function() {
            var $cloneButton = $('<a href="#" class="button color-event clone-button"><span class="icon icon-plus"></span>' +
                    $(this.element).data('clone-text') + '</a>');
            return $cloneButton;
        }

    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
